import ko from 'knockout';

export function registerComponent() {
  ko.components.register('weather-station', {
    viewModel: {
      createViewModel: function (params, componentInfo) {
        return new WeatherStationViewModel(params, componentInfo);
      },
    },
    template: '<div>\
                 <h2>Wetterdaten</h2>\
                 <h3 class="mt-3">Temperaturen</h3>\
                 <div class="weather-chart" data-bind="component: { name: \'weather-chart\', params: { data: airTemperatures } }"></div>\
                 <h3 class="mt-3">Sonnenstunden</h3>\
                 <div class="weather-chart" data-bind="component: { name: \'weather-chart\', params: { data: hoursOfSunshine } }"></div>\
                 <h3 class="mt-3">Niederschlagsmenge</h3>\
                 <div class="weather-chart" data-bind="component: { name: \'weather-chart\', params: { data: precipitationElevation } }"></div>\
                 <h3 class="mt-3">Wassertemperaturen</h3>\
                 <div class="weather-chart" data-bind="component: { name: \'weather-chart\', params: { data: waterTemperatures } }"></div>\
               </div>',
  });
}

function WeatherStationViewModel(params) {
  var self = this;
  var data = params.data;

  self.airTemperatures = {
    datasets: [{
      label: 'Durchschnittstemperatur',
      backgroundColor: '#ec6e4b',
      data: data.AirTemperatures.map(function (number) {
        return number.toFixed(1);
      }),
    }],
    unit: '℃',
  };

  self.precipitationElevation = {
    datasets: [{
      label: 'Niederschlag',
      backgroundColor: '#2470ab',
      data: data.PrecipitationElevation.map(function (number) {
        return number.toFixed(0);
      }),
    }],
    unit: 'mm',
  };

  self.hoursOfSunshine = {
    datasets: [{
      label: 'Sonnenscheindauer',
      backgroundColor: '#fcc043',
      data: data.HoursOfSunshine.map(function (number) {
        return number.toFixed(1);
      }),
    }],
    unit: 'Stunden',
  };

  self.waterTemperatures = {
    datasets: [{
      label: 'Wassertemperatur',
      backgroundColor: '#145e93',
      data: [3, 2, 3, 5, 9, 13, 17, 17, 15, 12, 8, 5],
    }],
    unit: '℃',
  };
}
